module.exports = __webpack_public_path__ + "static/media/alerta-taller-verde.3a699fba.svg";